import type { EntityProfileModule } from '../types';
import {
  fetchPartnerProfile,
  savePartnerProfile,
  type PartnerProfileData,
} from '../api/partner-profile.api';
import { PartnerProfileSections } from './partner/PartnerProfileSections';

export const partnerProfileModule: EntityProfileModule<PartnerProfileData> = {
  status: 'ready',
  queryKey: (entityId) => ['profile', 'partner', entityId],
  fetch: fetchPartnerProfile,
  save: savePartnerProfile,
  Sections: PartnerProfileSections,
};
